module.exports = __webpack_public_path__ + "img/liveCard_hot.cdca8d0d.png";